import React from 'react';
import { gettext } from '@eventbrite/i18n';
import {
    getHeapDataAttribute,
    HeapAttributes,
} from '@eventbrite/marketing-tools-common';
import { Badge, IconButton, Typography } from '@eventbrite/marmalade';
import {
    getFlexDiscountedPricesForTLD,
    getPlanOptions,
    getPricesAndCurrencyCodeForTLD,
    PLAN_PERKS,
    PRICING_FLEX_CTA_BUTTON_EVENT,
    PRICING_PRO_CTA_BUTTON_EVENT,
} from './pricingAndPackagingUtils';
import { PricingCard } from './PricingCard';
import { SparklingSvg } from './SVGs/SparklingSvg';
import styles from './PricingAndPackagingComparisonCards.module.scss';

const { Teams, Features, Components, Actions } = HeapAttributes;

const getCardDetails = () => {
    const priceAndCC = getPricesAndCurrencyCodeForTLD();
    const priceMapping = priceAndCC.priceMapping;
    const currencyCode = priceAndCC.currencyCode;
    const planOptions = getPlanOptions(priceMapping);
    return [
        {
            isRecommended: false,
            planName: gettext('Flex'),
            planIcon: null,
            subtext: gettext('Included benefits'),
            currencyCode: currencyCode,
            cost: 'Free',
            discountedCost: null,
            costText: gettext('/ event'),
            perks: PLAN_PERKS.FLEX,
            selectedDropdownOption: gettext('Up to 25'),
            planOptions: planOptions.FLEX,
            optionsHeapId:
                'organizer-pricing-all-click-pricing-card-flex-capacities',
            statsigEventName: PRICING_FLEX_CTA_BUTTON_EVENT,
            cta: {
                link: '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F',
                icon: null,
                text: gettext('Get started'),
                heapId: getHeapDataAttribute({
                    team: Teams.Marketing,
                    feature: Features.PricingPage,
                    component: Components.FlexPlanCardCTA,
                    action: Actions.Click,
                }),
            },
        },
        {
            isRecommended: true,
            planName: gettext('Pro'),
            subtext: gettext('Included benefits'),
            currencyCode: currencyCode,
            cost: priceMapping.proPlan.liteTier,
            discountedCost: priceMapping.freePlan.freeTier,
            costText: gettext('for 14 days'),
            perks: PLAN_PERKS.PRO,
            selectedDropdownOption: gettext('Up to 100'),
            planOptions: planOptions.PRO,
            optionsHeapId:
                'organizer-pricing-all-click-pricing-card-pro-capacities',
            statsigEventName: PRICING_PRO_CTA_BUTTON_EVENT,
            cta: {
                link: '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F',
                icon: <IconButton />,
                text: gettext('Try for free'),
                heapId: getHeapDataAttribute({
                    team: Teams.Marketing,
                    feature: Features.PricingPage,
                    component: Components.ProPlanCardCTA,
                    action: Actions.Click,
                }),
            },
        },
        {
            isRecommended: false,
            planName: gettext('Partner'),
            planIcon: null,
            subtext: gettext('Included benefits'),
            currencyCode: null,
            cost: null,
            discountedCost: null,
            costText: null,
            perks: PLAN_PERKS.PARTNER,
            statsigEventName: '',
            cta: {
                link: '/l/contact-eventbrite-sales/',
                text: gettext('Talk with us'),
                heapId: getHeapDataAttribute({
                    team: Teams.Marketing,
                    feature: Features.PricingPage,
                    component: Components.PremiumPlanCardCTA,
                    action: Actions.Click,
                }),
            },
        },
    ];
};

export const PricingAndPackagingComparisonCardsNew = () => {
    const cardDetails = getCardDetails();
    const locale = Intl.NumberFormat().resolvedOptions().locale;

    return (
        <div className={styles.comparisonCardsContainer}>
            <div className={styles.cards}>
                {cardDetails.map((card, i) => {
                    return <PricingCard {...card} key={i} />;
                })}
            </div>
            <div className={styles.separator}>
                <div className={styles.line} />
                <Typography
                    variant="display-sm"
                    className={styles.separator_text}
                >
                    {gettext('INCLUDED IN EVERY PLAN')}
                </Typography>
                <div className={styles.line} />
            </div>
        </div>
    );
};

export default PricingAndPackagingComparisonCardsNew;
